export default __webpack_public_path__ + "static/media/search.da31117f.svg";